import HeroMessageAr from './HeroMessageAr'
import HeroMessageEn from './HeroMessageEn'
import { useParams } from 'react-router'

export default function Hero() {
  const { lng } = useParams()

  return (
    <div className="bg-primary-600 relative z-0 h-screen">
      <video
        autoPlay
        loop
        muted
        className="h-full w-full object-cover"
      >
        <source
          src="/assets/videos/home/hero_background.mp4"
          type="video/webm"
        />
      </video>
      <div className="absolute inset-0 bg-gradient-to-t from-black to-dark opacity-20" />
      <div className="absolute inset-0 mt-28 flex items-center justify-center lg:justify-start">
        <div
          className="app-container"
          data-aos="fade-up"
        >
          {lng === 'ar' ? <HeroMessageAr /> : <HeroMessageEn />}
        </div>
      </div>
    </div>
  )
}
